import { Navigate } from "react-router-dom";

//pages

//login
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Error404 from "pages/Error/Error404";
import TaskMilestone from "pages/Task";
import Collaborations from "pages/Collaboration";
import Campaigns from "pages/Campaign";
import CollaborationChat from "pages/Collaboration/Chat";
import CampaignsActivities from "pages/Campaign/Activities";
import CampaignInfo from "pages/Campaign/Edit/CampaignInfo";
import CampaignProduct from "pages/Campaign/Edit/CampaignProduct";
import CampaignCreators from "pages/Campaign/Edit/CampaignCreators";
import CampaignDeliverables from "pages/Campaign/Edit/CampaignDeliverables";
import CampaignControls from "pages/Campaign/Edit/CampaignControls";
import CampaignPaymentTerms from "pages/Campaign/Edit/CampaignPaymentTerms";
import CampaignCreativesV2 from "pages/Campaign/Edit/CampaignCreatives";
import Campaign from "pages/Campaign/Campaign";
import CampaignApplications from "pages/Campaign/Applications";
import CampaignCollaborations from "pages/Campaign/Collaborations";
import CampaignInsights from "pages/Campaign/Insights";
import CreatorDiscovery from "pages/CreatorDiscovery";
import RecommendedCreators from "pages/Campaign/RecommendedCreators";
import InvitedCreators from "pages/Campaign/Invitation";
import CreatorDM from "pages/CreatorDM";
import CollabDeletionRequests from "pages/Collaboration/DeletionRequest";
import Invites from "pages/Invite";

// Landing Index

// User Profile

const authProtectedRoutes = [
 
  // { path: "/collaboration", component: <h6>Collaboration</h6> },
  // { path: "/user", component: <UsersList /> },
  // { path: "/user/create", component: <CreateUser /> },
  // { path: "/user/:userId", component: <EditUser /> },
  { path: "/tasks", component: <TaskMilestone /> },
  { path: "/tasks/:campaignId/collaboration/:collaborationId/milestone/:milestoneId", component: <TaskMilestone /> },
  { path: "/tasks/:campaignId/collaboration/:collaborationId", component: <TaskMilestone /> },
  { path: "/campaign-activities", component: <CampaignsActivities /> },
  { path: "/campaign", component: <Campaigns /> },
  { path: "/campaign/:campaignId", exact: true, component: <Campaign /> },
  { path: '/campaign/:campaignId/applications', exact: true, component: <CampaignApplications /> },
  { path: '/campaign/:campaignId/shortlisted', exact: true, component: <CampaignApplications /> },
  { path: '/campaign/:campaignId/collaborations', exact: true, component: <CampaignCollaborations /> },
  { path: '/campaign/:campaignId/insights', exact: true, component: <CampaignInsights /> },
  { path: '/campaign/:campaignId/recommended-creators', exact: true, component: <RecommendedCreators /> },
  { path: '/campaign/:campaignId/edit', exact: true, component: <CampaignInfo /> },
  { path: '/campaign/:campaignId/gigs', exact: true, component: <CampaignProduct /> },
  { path: '/campaign/:campaignId/creators', exact: true, component: <CampaignCreators /> },
  { path: '/campaign/:campaignId/deliverables', exact: true, component: <CampaignDeliverables /> },
  { path: '/campaign/:campaignId/payment-terms', exact: true, component: <CampaignPaymentTerms /> },
  { path: '/campaign/:campaignId/controls', exact: true, component: <CampaignControls /> },
  { path: '/campaign/:campaignId/banner', exact: true, component: <CampaignCreativesV2 /> },
  { path: '/campaign/:campaignId/invites', exact: true, component: <InvitedCreators /> },
  { path: '/chat', exact: true, component: <CollaborationChat /> },
  { path: '/chat/:uuid', exact: true, component: <CollaborationChat /> },
  { path: '/creator-discovery', exact: true, component: <CreatorDiscovery /> },
  { path: '/creator-discovery/:discoveryId', exact: true, component: <CreatorDiscovery /> },
  { path: '/creator-dm', exact: true, component: <CreatorDM /> },
  { path: '/creator-dm/:sessionId', exact: true, component: <CreatorDM /> },
  { path: '/collab-deletion-request', exact: true, component: <CollabDeletionRequests /> },
  { path: '/invites', exact: true, component: <Invites /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/tasks" />,
  },
  { path: "*", component: <Error404 /> },  
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },


];

export { authProtectedRoutes, publicRoutes };